import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InfoLineContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${Spacing.S4};
`

export const GridLine = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  & > * {
    min-width: 110px;
    padding: ${Spacing.S4} ${Spacing.S8};
  }

  & > *:not(:first-of-type) {
    text-align: right;
  }
`

export const AccountDataContainer = styled.div`
  flex: auto;
  max-width: 320px;

  & > *:not(:last-of-type) {
    border-bottom: 1px solid #e6e6e6;
  }
`

export const BalanceTable = styled.div`
  max-width: 470px;

  & > *:nth-of-type(odd) {
    background-color: ${Color.Lavender50};
  }
`
